import React from "react";
import { showExpiredTravelZonesAtom } from "./analysisAtoms";
import { SwitchControl } from "./SwitchControl";
export const ExpiredTravelZonesSwitchControl = () => {
    return (
        <SwitchControl
            atom={showExpiredTravelZonesAtom}
            label="Show expired travel zones"
            name="expiredTravelZones"
        />
    );
};
